import { updateObject } from '../../helpers/utility.helper';
import { initialState } from '../state/column.state';
import userSettingType from '../types/column.type';
import IColumnState from '../models/IColumnState';

const getUserSettingStart = (oldState: IColumnState, action: any) => {
    return updateObject(oldState, {
        columnLists: updateObject(oldState.columnLists, {
            error: null, loading: true
        })
    });
};

const getDataRangeStart = (oldState: IColumnState, action: any) => {
    return updateObject(oldState, {
        columnLists: updateObject(oldState.columnLists, {
            error: null, loading: true
        })
    });
};

const resetUsersettingState = (oldState: IColumnState, action: any) => {
    return updateObject(oldState, {
        columnLists: updateObject(oldState.columnLists, {
            error: null, loading: false, success: false, columns: undefined
        })
    });
};

const resetUsersettingSuccessState = (oldState: IColumnState, action: any) => {
    return updateObject(oldState, {
        columnLists: updateObject(oldState.columnLists, {
            error: null, loading: false, success: false
        })
    });
};

const resetDataRangeState = (oldState: IColumnState, action: any) => {
    return updateObject(oldState, {
        dataRange: updateObject(oldState.dataRange, {
            data: undefined, error: null, loading: false, success: false
        })
    });
};
 

const resetUsersettingAddState = (oldState: IColumnState, action: any) => {
    return updateObject(oldState, {
        addColumn: updateObject(oldState.addColumn, {
            loading: false,
            success: false,
            error: null
        })
    });
};


const getUserSettingSuccess = (oldState: IColumnState, action: any) => {
    return updateObject(oldState, {
        columnLists: updateObject(oldState.columnLists, {
            columns: action.payload,
            success: true,
            error: null,
            loading: false
        })
    });
};

const getDataRangeSuccess = (oldState: IColumnState, action: any) => {
    return updateObject(oldState, {
        dataRange: updateObject(oldState.dataRange, {
            data: action.payload,
            success: true,
            error: null,
            loading: false
        })
    });
};

const getUserSettingError = (oldState: IColumnState, action: any) => {
    return updateObject(oldState, {
        columnLists: updateObject(oldState.columnLists, {
            error: action.payload,
            loading: false,
            success: false
        })
    });
};

const getDataRangeError = (oldState: IColumnState, action: any) => {
    return updateObject(oldState, {
        columnLists: updateObject(oldState.columnLists, {
            error: action.payload,
            loading: false,
            success: false
        })
    });
};


const addUserSettingStart = (oldState: IColumnState, action: any) => {
    return updateObject(oldState, {
        addColumn: updateObject(oldState.addColumn, {
            loading: true,
            success: false,
            error: null
        })
    });
};

const addUserSettingSuccess = (oldState: IColumnState, action: any) => {
    return updateObject(oldState, {
        addColumn: updateObject(oldState.addColumn, {
            success: true,
            error: null,
            loading: false
        })
    });
};

const addUserSettingError = (oldState: IColumnState, action: any) => {
    return updateObject(oldState, {
        addColumn: updateObject(oldState.addColumn, {
            success: false,
            error: action.payload,
            loading: false
        })
    });
};


const userSettingReducer = (oldState: IColumnState = initialState, action: any) => {
    switch (action.type) {

        case userSettingType.ADD_USER_SETTING_START: return addUserSettingStart(oldState, action);
        case userSettingType.ADD_USER_SETTING_SUCCESS: return addUserSettingSuccess(oldState, action);
        case userSettingType.ADD_USER_SETTING_ERROR: return addUserSettingError(oldState, action);
        case userSettingType.GET_USER_SETTING_START: return getUserSettingStart(oldState, action);
        case userSettingType.GET_USER_SETTING_SUCCESS: return getUserSettingSuccess(oldState, action);
        case userSettingType.GET_USER_SETTING_ERROR: return getUserSettingError(oldState, action);
        case userSettingType.RESET_USER_SETTING_STATE: return resetUsersettingState(oldState, action);
        case userSettingType.RESET_USER_SETTING_ADD_STATE: return resetUsersettingAddState(oldState, action);
        case userSettingType.RESET_USER_SETTING_SUCCESS_STATE: return resetUsersettingSuccessState(oldState, action);
        case userSettingType.GET_DATA_RANGE_START: return getDataRangeStart(oldState, action);
        case userSettingType.GET_DATA_RANGE_SUCCESS: return getDataRangeSuccess(oldState, action);
        case userSettingType.GET_DATA_RANGE_ERROR: return getDataRangeError(oldState, action);
        case userSettingType.RESET_DATA_RANGE_STATE: return resetDataRangeState(oldState, action);
       
        default: return oldState;
    }
};
export default userSettingReducer;